import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import {
  COLOR_BUTTON_PRIMARY,
  COLOR_WHITE,
} from '@common/assets/styles/colors';
import svgCloseBtn from '@common/assets/svg/icon-cross.svg';

import svgHilbiLogoRounded from '@assets/svg/hilbi-logo-rounded.svg';
import userInterfaceStore from '@store/user-interface';

const HeaderSC = styled.div`
  height: 88px;
  position: relative;

  .blue-background {
    height: 63px;
    background-color: ${COLOR_BUTTON_PRIMARY};

    border-top-left-radius: ${({ theme }) => (theme.responsive ? '0' : '16px')};
    border-top-right-radius: ${({ theme }) =>
      theme.responsive ? '0' : '16px'};

    display: flex;
    align-items: center;
    justify-content: center;

    > span {
      font-size: 15px;
      line-height: 15px;
      font-weight: 800;
      color: ${COLOR_WHITE};
    }
  }

  svg:first-child {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    box-shadow: 0 1px 10px rgba(51, 61, 108, 0.3);
    position: absolute;
    top: 36px;
    left: 20px;
  }

  svg:not(:first-child) {
    top: 27px;
    right: 20px;
    position: absolute;
    cursor: pointer;

    g {
      stroke: ${COLOR_WHITE};
    }
  }

  .fill {
    background-color: ${COLOR_WHITE};
    height: 25px;
  }
`;

const Header = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  return (
    <HeaderSC>
      <SVG src={svgHilbiLogoRounded} />
      <div className="blue-background">
        <span>{formatMessage({ id: 'header.title' })}</span>
      </div>
      <SVG
        src={svgCloseBtn}
        onClick={() => {
          dispatch(userInterfaceStore.setWidgetOpen({ open: false }));
          window.parent.postMessage('hwwm-close_widget', '*');
        }}
      />
      <div className="fill" />
    </HeaderSC>
  );
};

export default Header;
